import * as React from "react";
import { Profiles } from "./ProfilesPage";
import { ProfilesProvider } from "./context/ProfileContext";

type Props = {};

const ProfilesPage = (props: Props) => {
	return (
		<ProfilesProvider>
			<Profiles />
		</ProfilesProvider>
	);
};

export default ProfilesPage;
